/** Mount the top HUD shell (clears the notch via --sat). */
export function mountHud(root: HTMLElement): void {
  root.innerHTML = `
    <div class="hud__chip hud__chip--gold" data-testid="hud-gold">0</div>
    <div class="hud__chip hud__chip--gem" data-testid="hud-gems">0</div>
  `;
}
